jQuery(function($){
    $('.company-testimonial').owlCarousel({
        loop:true,
        autoHeight: true,
        autoHeightClass: 'owl-height',
        margin:20,
        nav:true,
        dots:true,
        responsive:{
            0:{
                items:1
            },
            768:{
                items:2
            },
            1000:{
                items:3
            }
        }
    });
});
